import { makeStyles, Theme } from "@material-ui/core/styles";
import React from "react";
import TestSeriesVersionReferenceResponse from "../../../../api/models/test-series/TestSeriesVersionReferenceResponse";
import { StyledMenu } from "../../../../components/Menu/StyledMenu";
import { tesaBlue } from "../../../../styles/colors";
import TestRequestActionsMenuItem from "../../DescriptionTab/TestRequestActionsMenuItem";

const useStyles = makeStyles((theme: Theme) => ({
  hiddenButton: {
    backgroundColor: "transparent",
    border: 0,
    color: tesaBlue,
    cursor: "pointer",
    fontSize: "inherit",
    fontFamily: "inherit",
    lineHeight: 1,
    padding: 0,
    paddingLeft: theme.spacing(1),
  },
  moreVertIcon: {
    height: "14px",
  },
}));

interface TestSeriesVersionMenuProps {
  disabled?: boolean;
  versions: TestSeriesVersionReferenceResponse[];
  currentVersion: number;
  onSuccess: (data: any) => void;
}
function TestSeriesVersionMenu({
  currentVersion,
  disabled,
  onSuccess: handleSuccess,
  versions: versionReferences,
}: TestSeriesVersionMenuProps) {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const handleContextMenuClick = (event: React.MouseEvent<HTMLButtonElement>): void => {
    setAnchorEl(event.currentTarget);
  };
  const handleContextMenuClose = (): void => {
    setAnchorEl(null);
  };
  return (
    <>
      {versionReferences.length > 1 && (
        <button className={classes.hiddenButton} onClick={handleContextMenuClick} type="button">
          v{currentVersion}
        </button>
      )}
      <StyledMenu
        id="customized-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleContextMenuClose}
      >
        {versionReferences.reduce<JSX.Element[]>((menuItems, currVr) => {
          const { version } = currVr;
          if (version !== currentVersion) {
            const versionName = `Show version ${version}`;
            menuItems.push(
              <TestRequestActionsMenuItem
                altLabel={versionName}
                aproe
                close={handleContextMenuClose}
                dialog={false}
                disabled={!!disabled}
                key={versionName}
                onConfirm={() => Promise.resolve(version)}
                onSuccessCallback={handleSuccess}
              />,
            );
            return menuItems;
          }
          return menuItems;
        }, [])}
      </StyledMenu>
    </>
  );
}

export default TestSeriesVersionMenu;
